<ion-modal
  class="app-side-panel-modal"
  [isOpen]="isOpen()"
  [enterAnimation]="enterAnimation"
  [leaveAnimation]="leaveAnimation"
  (didDismiss)="handleDidDismiss()"
>
  <ng-template>
    <div class="h-full w-full flex flex-col bg-surface">
      <header
        class="shrink-0 pad-safe-area-top flex items-center justify-between px-5 !pt-6 pb-3 bg-surface border-b border-[var(--outline-color)]"
      >
        <span class="header-font text-xl font-semibold text-[var(--ion-text-color)]">
          {{ title() }}
        </span>
        @if (showCloseButton()) {
          <app-icon-button
            icon="close"
            size="md"
            color="danger"
            ariaLabel="Close"
            [noBackground]="true"
            [border]="false"
            [shadow]="false"
            (click)="close()"
          ></app-icon-button>
        }
      </header>
      <div class="flex-1 min-h-0 overflow-y-auto p-5">
        <ng-content></ng-content>
      </div>
    </div>
  </ng-template>
</ion-modal>
